<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconFecc_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="m14.534 9.47-2.164 2.164-.735-.735L13.8 8.735a1.04 1.04 0 0 0 0-1.471l-2.165-2.165.736-.736 2.164 2.165a2.08 2.08 0 0 1 0 2.942M7.265 2.2 5.101 4.364l-.735-.735L6.53 1.465a2.08 2.08 0 0 1 2.941 0l2.163 2.163-.735.736L8.736 2.2a1.04 1.04 0 0 0-1.47 0M4.366 5.1l-.735-.736-2.164 2.164a2.08 2.08 0 0 0 0 2.942l2.163 2.164.736-.736-2.164-2.163a1.04 1.04 0 0 1 0-1.471zm7.27 7.27-.736-.736-2.164 2.164a1.04 1.04 0 0 1-1.47 0L5.1 11.634l-.735.735 2.164 2.164a2.08 2.08 0 0 0 2.941 0zM8 10.121a2.123 2.123 0 1 0 0-4.245 2.123 2.123 0 0 0 0 4.245"
        clip-rule="evenodd"
    />
</svg>
